export default "<m-cube\n    color=\"purple\"\n    x=\"4\"\n    y=\"2\"\n    z=\"5\"\n></m-cube>\n";